<h4 class="page-title"><i class="fe-star-on fa-lg" style="color: #f5b106;"></i> Avaliações de Pedidos</h4>

<div class="avaliacoes">
  <div class="resumo">
    <div class="resumo-card">
      <span class="resumo-rotulo">Nota média geral</span>
      <div class="resumo-nota">
        <span class="resumo-valor">{{(notaGeral?.media || 0) | number: '1.1-1'}}</span>
        <span class="estrelas estrelas-grandes">
          <span class="estrelas-fundo">&#9733;&#9733;&#9733;&#9733;&#9733;</span>
          <span class="estrelas-cheias" [style.width.%]="percentualEstrelas(notaGeral?.media)">&#9733;&#9733;&#9733;&#9733;&#9733;</span>
        </span>
      </div>
      <span class="resumo-qtde">{{notaGeral?.qtdeAvaliacoes || 0}} avaliações no total</span>
    </div>

    <div class="resumo-card">
      <span class="resumo-rotulo">Últimos 30 dias</span>
      <div class="resumo-nota">
        <span class="resumo-valor">{{(notaMediaUltimos30Dias?.media || 0) | number: '1.1-1'}}</span>
        <span class="estrelas estrelas-grandes">
          <span class="estrelas-fundo">&#9733;&#9733;&#9733;&#9733;&#9733;</span>
          <span class="estrelas-cheias" [style.width.%]="percentualEstrelas(notaMediaUltimos30Dias?.media)">&#9733;&#9733;&#9733;&#9733;&#9733;</span>
        </span>
      </div>
      <span class="resumo-qtde">{{notaMediaUltimos30Dias?.qtdeAvaliacoes || 0}} avaliações no período</span>
    </div>
  </div>

  <section class="publicacao" aria-labelledby="publicacao-titulo">
    <div class="publicacao-config">
      <div class="publicacao-cabecalho">
        <span class="publicacao-icone"><i class="fe-shopping-bag"></i></span>
        <div>
          <h5 id="publicacao-titulo" class="publicacao-titulo">Avaliações na sua loja</h5>
          <span class="publicacao-sub">Mostre no cardápio o que os clientes dizem de você. Só aparece o que você escolher.</span>
        </div>
      </div>

      <div class="publicacao-regra">
        <span class="publicacao-rotulo" id="publicar-automatico-rotulo">Publicar automaticamente</span>
        <div class="segmentado" role="radiogroup" aria-labelledby="publicar-automatico-rotulo">
          <button type="button" role="radio" class="segmento" *ngFor="let opcao of opcoesPublicarAutomatico"
                  [class.ativo]="publicacao.notaMinima === opcao.valor" [attr.aria-checked]="publicacao.notaMinima === opcao.valor"
                  [disabled]="publicacao.salvando || !publicacao.carregada" (click)="escolhaPublicarAutomatico(opcao.valor)">
            {{opcao.descricao}}<span class="segmento-estrela" *ngIf="opcao.valor"> &#9733;</span>
          </button>
        </div>
        <p class="publicacao-explicacao">{{explicacaoRegra}}</p>
        <p class="publicacao-aviso" *ngIf="publicacao.notaMinima">
          <i class="fe-info"></i>
          <span>Vale também para as avaliações que você já recebeu. As que você publicou ou tirou à mão continuam como estão.</span>
        </p>
        <p class="publicacao-erro" *ngIf="publicacao.erro"><i class="fe-alert-circle"></i> {{publicacao.erro}}</p>
      </div>
    </div>

    <div class="previa">
      <span class="previa-rotulo">Como o cliente vê</span>
      <div class="previa-loja" aria-hidden="true">
        <span class="previa-capa"></span>
        <div class="previa-ficha">
          <span class="previa-logo"></span>
          <div class="previa-linhas">
            <span class="previa-linha previa-linha-nome"></span>
            <span class="selo" *ngIf="publicacao.resumoPublico?.total">
              <span class="selo-estrela">&#9733;</span>
              <strong>{{publicacao.resumoPublico.media | number: '1.1-1'}}</strong>
              <span class="selo-ponto">·</span>
              {{publicacao.resumoPublico.total}} {{publicacao.resumoPublico.total === 1 ? 'avaliação' : 'avaliações'}}
              <i class="fe-chevron-right"></i>
            </span>
            <span class="previa-linha previa-linha-curta" *ngIf="!publicacao.resumoPublico?.total"></span>
          </div>
        </div>
      </div>
      <span class="previa-legenda" *ngIf="publicacao.carregada && !publicacao.resumoPublico?.total">
        Nenhuma avaliação publicada: o selo aparece na loja assim que houver a primeira.
      </span>
      <span class="previa-legenda" *ngIf="publicacao.resumoPublico?.total && publicacao.notaMinima === 5">
        Com só 5 estrelas na loja, a nota do selo fica sempre 5,0.
      </span>
      <span class="previa-legenda" *ngIf="publicacao.resumoPublico?.total && publicacao.notaMinima !== 5">
        Média e total contam só as avaliações que estão na loja.
      </span>
    </div>
  </section>

  <div class="lista">
    <div class="lista-topo">
      <span class="lista-titulo">Avaliações recebidas</span>
      <div class="lista-topo-acoes">
        <span class="lista-contagem" *ngIf="total > 0">{{total}} {{total === 1 ? 'avaliação' : 'avaliações'}}{{temFiltro ? ' no filtro' : ''}}</span>
        <select class="filtro-periodo" aria-label="Ordenar" [(ngModel)]="ordem" (ngModelChange)="carregue(0)">
          <option *ngFor="let opcao of opcoesOrdem" [value]="opcao.valor">{{opcao.descricao}}</option>
        </select>
      </div>
    </div>

    <div class="filtros">
      <div class="filtro-busca">
        <i class="fe-search"></i>
        <input type="text" placeholder="Buscar cliente ou telefone" [(ngModel)]="filtro.termo" (ngModelChange)="digitouBusca()">
      </div>

      <div class="filtro-grupo">
        <span class="filtro-rotulo">Nota</span>
        <button type="button" class="pilula" *ngFor="let nota of opcoesNota"
                [class.ativa]="filtro.nota === nota" (click)="escolhaNota(nota)">
          {{nota}} <span class="pilula-estrela">&#9733;</span>
        </button>
      </div>

      <div class="filtro-grupo">
        <span class="filtro-rotulo">Entrega</span>
        <button type="button" class="pilula" *ngFor="let opcao of opcoesEntrega"
                [class.ativa]="filtro.entrega === opcao.valor" (click)="escolhaEntrega(opcao.valor)">
          {{opcao.descricao}}
        </button>
      </div>

      <div class="filtro-grupo">
        <span class="filtro-rotulo">Loja</span>
        <button type="button" class="pilula" *ngFor="let opcao of opcoesNaLoja"
                [class.ativa]="filtro.naLoja === opcao.valor" (click)="escolhaNaLoja(opcao.valor)">
          {{opcao.descricao}}
        </button>
      </div>

      <div class="filtro-grupo">
        <select class="filtro-periodo" [(ngModel)]="filtro.dias" (ngModelChange)="carregue(0)">
          <option *ngFor="let opcao of opcoesPeriodo" [value]="opcao.valor">{{opcao.descricao}}</option>
        </select>

        <button type="button" class="pilula" [class.ativa]="filtro.comentario" (click)="alterneComentario()">
          <i class="fe-message-square"></i> Com comentário
        </button>

        <button type="button" class="limpar" *ngIf="temFiltro" (click)="limpeFiltros()">Limpar filtros</button>
      </div>
    </div>

    <div class="lista-corpo" [class.carregando]="loading && avaliacoes.length">
      <div class="estado" *ngIf="loading && !avaliacoes.length">
        <i class="fas fa-spinner fa-spin spinner"></i>
        <span>Carregando avaliações…</span>
      </div>

      <div class="estado estado-erro" *ngIf="!loading && erro">
        <i class="fe-alert-circle"></i>
        <span>{{erro}}</span>
        <button type="button" class="btn btn-sm btn-light" (click)="carregue(inicio)">Tentar de novo</button>
      </div>

      <div class="estado" *ngIf="!loading && !erro && !avaliacoes.length">
        <i class="fe-star"></i>
        <ng-container *ngIf="!temFiltro">
          <span class="estado-titulo">Nenhuma avaliação ainda</span>
          <span>Quando os clientes avaliarem os pedidos, as notas e comentários aparecem aqui.</span>
        </ng-container>
        <ng-container *ngIf="temFiltro">
          <span class="estado-titulo">Nenhuma avaliação com esses filtros</span>
          <button type="button" class="limpar" (click)="limpeFiltros()">Limpar filtros</button>
        </ng-container>
      </div>

      <div class="avaliacao" *ngFor="let avaliacao of avaliacoes">
        <div class="avatar" [class.avatar-baixa]="avaliacao.nota <= 2">{{iniciais(avaliacao.pedido?.cliente?.nome)}}</div>

        <div class="avaliacao-conteudo">
          <div class="avaliacao-topo">
            <a class="cliente" [href]="'/admin/contatos/' + avaliacao.pedido?.cliente?.codigoPais + avaliacao.pedido?.cliente?.telefone">
              {{avaliacao.pedido?.cliente?.nome}}
            </a>
            <span class="avaliacao-data">
              {{avaliacao.data | date: 'dd/MM/yy'}}
              <span *ngIf="avaliacao.tempoAvaliarDescricao"> · {{tempoParaAvaliar(avaliacao)}} após o pedido</span>
            </span>
          </div>

          <div class="avaliacao-nota">
            <span class="estrelas" [class.estrelas-baixa]="avaliacao.nota <= 2">
              <span *ngFor="let estrela of estrelas" [class.cheia]="estrela <= avaliacao.nota">&#9733;</span>
            </span>
            <span class="chip" [class.chip-positivo]="avaliacao.gostouDaEntrega" [class.chip-negativo]="!avaliacao.gostouDaEntrega">
              <i class="fas" [class.fa-thumbs-up]="avaliacao.gostouDaEntrega" [class.fa-thumbs-down]="!avaliacao.gostouDaEntrega"></i>
              {{avaliacao.gostouDaEntrega ? 'Gostou da entrega' : 'Não gostou da entrega'}}
            </span>
            <span class="chip chip-loja" [class.chip-na-loja]="avaliacao.estadoNaLoja !== 'FORA'">
              <i [class]="avaliacao.estadoNaLoja !== 'FORA' ? 'fe-eye' : 'fe-eye-off'"></i>
              {{descricaoEstadoNaLoja(avaliacao)}}
            </span>
          </div>

          <p class="comentario" *ngIf="avaliacao.comentario">“{{avaliacao.comentario}}”</p>
          <p class="comentario comentario-vazio" *ngIf="!avaliacao.comentario">Sem comentário</p>

          <div class="avaliacao-meta">
            <a class="meta-pedido"
               [routerLink]="(modoGrupoLojas ? ('/admin-grupo/pedidos/detalhes/' + avaliacao.pedido?.empresa?.id + '/') : '/admin/pedidos/detalhes/') + avaliacao.pedido?.guid">
              Pedido #{{avaliacao.pedido?.codigo}}
            </a>
            <span>{{avaliacao.pedido?.total | currency: 'BRL'}}</span>
            <span>{{avaliacao.pedido?.horarioVenda | date: 'dd/MM/yy HH:mm'}}</span>
            <app-pedido-origem [pedido]="avaliacao.pedido"></app-pedido-origem>
            <a class="meta-whatsapp" *ngIf="avaliacao.pedido?.cliente?.telefone"
               [href]="'/admin/contatos/' + avaliacao.pedido?.cliente?.codigoPais + avaliacao.pedido?.cliente?.telefone">
              <i class="fab fa-whatsapp"></i> {{avaliacao.pedido.cliente.telefone | mask: '(99) 9-9999-9999'}}
            </a>

            <div class="loja-acoes">
              <button type="button" class="seguir-regra" *ngIf="avaliacao.publicacao" [disabled]="avaliacao.salvandoPublicacao"
                      title="Apaga a sua escolha e volta a valer a publicação automática" (click)="altereVisibilidade(avaliacao, null)">
                Seguir a regra
              </button>
              <button type="button" class="acao-loja acao-publicar" *ngIf="avaliacao.estadoNaLoja === 'FORA'"
                      [disabled]="avaliacao.salvandoPublicacao" (click)="altereVisibilidade(avaliacao, 'PUBLICADA')">
                <i class="fe-eye"></i> Publicar na loja
              </button>
              <button type="button" class="acao-loja" *ngIf="avaliacao.estadoNaLoja && avaliacao.estadoNaLoja !== 'FORA'"
                      [disabled]="avaliacao.salvandoPublicacao" (click)="altereVisibilidade(avaliacao, 'OCULTA')">
                <i class="fe-eye-off"></i> Tirar da loja
              </button>
            </div>
          </div>
          <p class="publicacao-erro" *ngIf="avaliacao.erroPublicacao"><i class="fe-alert-circle"></i> {{avaliacao.erroPublicacao}}</p>
        </div>
      </div>
    </div>

    <div class="paginacao" *ngIf="totalPaginas > 1">
      <span class="paginacao-info">Mostrando {{inicio + 1}}–{{ultimoItemDaPagina}} de {{total}}</span>

      <div class="paginacao-botoes">
        <button type="button" class="pagina pagina-seta" [disabled]="paginaAtual === 1 || loading" (click)="vaParaPagina(paginaAtual - 1)">
          <i class="fe-chevron-left"></i> <span class="seta-texto">Anterior</span>
        </button>

        <ng-container *ngFor="let pagina of paginas">
          <span class="reticencias" *ngIf="!pagina">…</span>
          <button type="button" class="pagina pagina-numero" *ngIf="pagina" [class.ativa]="pagina === paginaAtual"
                  [disabled]="loading" (click)="vaParaPagina(pagina)">{{pagina}}</button>
        </ng-container>

        <span class="pagina-compacta">{{paginaAtual}} de {{totalPaginas}}</span>

        <button type="button" class="pagina pagina-seta" [disabled]="paginaAtual === totalPaginas || loading" (click)="vaParaPagina(paginaAtual + 1)">
          <span class="seta-texto">Próxima</span> <i class="fe-chevron-right"></i>
        </button>
      </div>
    </div>
  </div>
</div>
